var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getLocalUrl } from '@/main/utils/file-utils';
import { Storage } from 'aws-amplify';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { CircleSpinner } from '..';
import Styles from './img-s3-styles.scss';
const ImageS3 = (_a) => {
    var { bucketKey, style, defaultImage, className } = _a, props = __rest(_a, ["bucketKey", "style", "defaultImage", "className"]);
    const [url, setUrl] = useState(null);
    const [error, setError] = useState(false);
    const imageUrl = useMemo(() => url, [url]);
    const getUrl = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield Storage.get(bucketKey, { download: true });
            setUrl(getLocalUrl(result.Body));
        }
        catch (error) {
            console.error(error);
            setError(true);
        }
    });
    useEffect(() => {
        if (bucketKey)
            getUrl();
    }, [bucketKey]);
    if (defaultImage && ((!bucketKey && !imageUrl) || error))
        return defaultImage;
    if (error)
        return React.createElement("img", Object.assign({ className: classNames(Styles.noImage, className), style: Object.assign({}, style) }, props));
    if (imageUrl) {
        return React.createElement("img", Object.assign({ src: imageUrl, style: Object.assign({}, style), className: className }, props));
    }
    else {
        return (React.createElement("div", Object.assign({ style: Object.assign({}, style), className: classNames('d-flex justify-content-center align-items-center', className) }, props),
            React.createElement(CircleSpinner, null)));
    }
};
export default ImageS3;
